/* Vienetta Hesaba Özel Sepet Senkronizasyonu
 *
 * Sepet içeriği tarayıcı çerezinde değil, müşteri hesabına (Shopify customer email)
 * bağlı backend'de tutulur. Hesap hangi cihaz/tarayıcıda açılırsa açılsın kendi sepeti
 * gelir; aynı tarayıcıda başka hesap açılınca onun sepeti görünür.
 *
 * - GİRİŞ / sayfa yükleme: backend sepeti çekilir; Shopify sepeti farklıysa backend
 *   uygulanır (backend = doğru kaynak). Tam eşitlenince UI için bir kez yenilenir.
 * - DEĞİŞİM: /cart/add|change|update|clear sonrası Shopify sepeti backend'e yazılır.
 * - ÇIKIŞ: /account/logout linkine basınca Shopify sepeti temizlenir.
 *
 * Kimlik: window.customerData.email (yalnız giriş yapmış müşteride tanımlı). Misafirde
 * senkron çalışmaz. Marka backend'de brand='vienetta' -> KZK sepetiyle çakışmaz.
 */
(function () {
  'use strict';

  var API = window.KZK_API_BASE || 'https://senko.toserof.com';
  var CART_URL = API + '/api/vienetta-cart';
  var _applying = false;
  var _pushTimer = null;
  var _syncing = false;

  function email() { return (window.customerData && window.customerData.email) || ''; }
  function loggedIn() { return !!email(); }

  function getShopifyCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function itemsKey(items) {
    return (items || []).map(function (i) { return (i.id != null ? i.id : i.variant_id) + ':' + i.quantity; }).sort().join('|');
  }
  function mapItems(items) {
    return (items || []).map(function (i) {
      var o = { id: i.id, quantity: i.quantity };
      if (i.properties && Object.keys(i.properties).length) o.properties = i.properties;
      return o;
    });
  }

  // Ön bellekteki (Shopify) sepet + hesabın (backend) sepetini BİRLEŞTİR: hiçbiri
  // kaybolmasın. Aynı ürün (variant + properties) iki tarafta da varsa adet MAX alınır
  // (çift eklemeyi önler); farklı ürünler ikisinden de gelir.
  function itemUid(i) {
    var id = (i.id != null ? i.id : i.variant_id);
    return id + '::' + JSON.stringify(i.properties || {});
  }
  function mergeCarts(backendItems, shopifyItems) {
    var map = {};
    (backendItems || []).forEach(function (i) {
      map[itemUid(i)] = { id: (i.id != null ? i.id : i.variant_id), quantity: i.quantity, properties: i.properties };
    });
    (shopifyItems || []).forEach(function (i) {
      var k = itemUid(i);
      if (map[k]) map[k].quantity = Math.max(map[k].quantity, i.quantity);
      else map[k] = { id: (i.id != null ? i.id : i.variant_id), quantity: i.quantity, properties: i.properties };
    });
    return Object.keys(map).map(function (k) { return map[k]; });
  }

  function saveToBackend(items) {
    return fetch(CART_URL, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email(), items: mapItems(items) })
    });
  }

  // "Ön bellek bu hesap için birleştirildi mi?" bayrağı (tarayıcı + hesap bazlı).
  // İlk girişte ön bellek + backend birleşir; sonra backend doğru kaynak olur
  // (ön bellek bir daha üzerine yazmaz, silinen ürün geri gelmez).
  function mergedFlagKey() { return 'vie_cart_merged_' + email(); }
  function isMerged() { try { return localStorage.getItem(mergedFlagKey()) === '1'; } catch (e) { return false; } }
  function setMerged() { try { localStorage.setItem(mergedFlagKey(), '1'); } catch (e) {} }

  /* Shopify sepetini backend'e yaz (debounced) */
  function pushToBackend() {
    if (_applying || !loggedIn()) return;
    if (_pushTimer) clearTimeout(_pushTimer);
    _pushTimer = setTimeout(function () {
      _pushTimer = null;
      if (_applying || !loggedIn()) return;
      getShopifyCart().then(function (cart) {
        return fetch(CART_URL, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: email(), items: mapItems(cart.items) })
        });
      }).catch(function () {});
    }, 700);
  }

  /* Backend sepetini Shopify'a uygula (temizle + toplu ekle) */
  function applyToShopify(items) {
    _applying = true;
    return fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(function () {
        if (!items || !items.length) return null;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: mapItems(items) })
        });
      })
      .then(function () {
        try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
      })
      .catch(function () {})
      .finally(function () { _applying = false; });
  }

  /* Giriş / sayfa yükleme:
   *  - İLK giriş (bu tarayıcı+hesap için henüz birleşmemiş): ön bellekteki (Shopify)
   *    sepet + hesabın (backend) sepeti BİRLEŞTİRİLİR -> ön bellek sepeti kaybolmaz.
   *  - Sonra: backend DOĞRU kaynak; Shopify ona eşitlenir (ön bellek bir daha üzerine
   *    yazmaz, silinen ürün geri gelmez). Hedef Shopify'a uygulanır + backend'e yazılır. */
  function syncFromBackend() {
    if (_syncing || !loggedIn()) return;
    _syncing = true;
    var firstTime = !isMerged();
    Promise.all([
      fetch(CART_URL + '?email=' + encodeURIComponent(email())).then(function (r) { return r.ok ? r.json() : null; }),
      getShopifyCart()
    ]).then(function (res) {
      var backend = res[0], shopify = res[1];
      if (!backend || !backend.ok) return;

      var target = firstTime ? mergeCarts(backend.items, shopify.items) : mapItems(backend.items);
      var targetKey = itemsKey(target);
      var shopifyChanged = targetKey !== itemsKey(shopify.items);
      var backendChanged = targetKey !== itemsKey(backend.items);

      if (!shopifyChanged && !backendChanged) { setMerged(); return; } // her şey senkron

      var chain = Promise.resolve();
      if (shopifyChanged) chain = chain.then(function () { return applyToShopify(target); });
      if (backendChanged) chain = chain.then(function () { return saveToBackend(target); });
      return chain.then(function () {
        setMerged(); // ön bellek artık backend'de -> bir daha birleştirme yapılmaz
        if (shopifyChanged) {
          return getShopifyCart().then(function (after) {
            if (itemsKey(after.items) === targetKey) window.location.reload();
          });
        }
      });
    }).catch(function () {}).finally(function () { _syncing = false; });
  }

  /* --- Cart yazma isteklerini yakala (fetch interception) --- */
  var _origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var isWrite = /\/cart\/(add|change|update|clear)(\.js)?(\?|$|#)/.test(url);
    var p = _origFetch.apply(this, arguments);
    if (isWrite && !_applying) {
      p.then(function (res) { if (res && res.ok) pushToBackend(); }).catch(function () {});
    }
    return p;
  };

  /* --- Çıkış: /account/logout linkine basınca Shopify sepetini temizle --- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="/account/logout"]');
    if (!a) return;
    try {
      if (navigator.sendBeacon) navigator.sendBeacon('/cart/clear.js');
      else fetch('/cart/clear.js', { method: 'POST', keepalive: true });
    } catch (err) {}
  }, true);

  /* Boot: girişliyse hemen eşitle */
  if (loggedIn()) syncFromBackend();
})();
